import 'regenerator-runtime';

import React from 'react';
import axios from 'axios';
import { addLocaleData } from 'react-intl';

import { WtlContext } from 'wtl-components-library/web/context/wtl-context';

import favIcon from './src/images/favicon.png';

// NOTE Add languages here (import intl locale to make messages work)
import enLocale from 'react-intl/locale-data/en';
import plLocale from 'react-intl/locale-data/pl';

import pl from './i18n/pl';
import en from './i18n/en';

export const localeData = { en, pl };
export const localeIntl = [
  ...enLocale,
  ...plLocale
];
export const availableLanguages = Object.keys(localeData);

addLocaleData(localeIntl);
// END of languages

export const config = {
  /**
   * Page URLs
   */
  SITE_URL: `https://getcommon.app/`,
  API_URL: 'https://j81eal5nn6.execute-api.us-east-1.amazonaws.com/wtl-live/',
  TWITTER_URL: 'https://getcommon.app/',

  /**
   * Metadata and SEO
   */
  FAV_ICON: favIcon,
  DEFAULT_LOCALE: 'en',
  DEFAULT_TITLE: `Common - Virtual Playground for Interior Designers and Furniture Makers`,
  SEO_LOGO: '',
  SEO_DESCRIPTION: `Virtual Playground for Interior Designers and Furniture Makers`,
  SEO_KEYWORDS: [
    'common app',
    'interior design app',
    'furniture makers'
  ],
  /**
   * Plugin Configuration
   */
  enabledPlugins: [
    
  ],
  demoAccounts: [

  ],

  /**
   * Third Party API
   */
  STRIPE_API_KEY: '',
  GOOGLE_TRACK_ID: '',
  GOOGLE_MAPS_API_KEY: '',
  GOOGLE_SEARCH_CONSOLE_VERIFICATION_ID: ''
};

export const schemaSettings = {
  COLUMN_COUNT: 24
};

export const getApiEndpoint = (endpoint) => `${config.API_URL}${endpoint}`;

export const callApi = (endpoint, method = 'GET', params, headers) => {
  let call = axios({
    method: method.toLowerCase(),
    url: getApiEndpoint(endpoint),
    withCredentials: false,
    params: method === 'GET' ? params : {},
    data: method === 'POST' ? params : {},
    headers
  });

  return call
  .then(response => {
    return response.data;
  });
}

// NOTE Rendering Context Wrapper
export const WtlContextWrapper = ({ children }) => (
  <WtlContext.Provider value={{
    config,
    availableLanguages,
    localeData,
    localeIntl
  }}>
    <>
      {children}
    </>
  </WtlContext.Provider>
);

console.log(`
██████╗ ██████╗ ███╗   ███╗███╗   ███╗ ██████╗ ███╗   ██╗     █████╗ ██████╗ ██████╗ 
██╔════╝██╔═══██╗████╗ ████║████╗ ████║██╔═══██╗████╗  ██║    ██╔══██╗██╔══██╗██╔══██╗
██║     ██║   ██║██╔████╔██║██╔████╔██║██║   ██║██╔██╗ ██║    ███████║██████╔╝██████╔╝
██║     ██║   ██║██║╚██╔╝██║██║╚██╔╝██║██║   ██║██║╚██╗██║    ██╔══██║██╔═══╝ ██╔═══╝ 
╚██████╗╚██████╔╝██║ ╚═╝ ██║██║ ╚═╝ ██║╚██████╔╝██║ ╚████║    ██║  ██║██║     ██║     
 ╚═════╝ ╚═════╝ ╚═╝     ╚═╝╚═╝     ╚═╝ ╚═════╝ ╚═╝  ╚═══╝    ╚═╝  ╚═╝╚═╝     ╚═╝     
                                                                                ® 2020-
                                                                  https://getcommon.app
`);
